import React from 'react';
import DownloadButtonNoName from './DownloadButtonNoName';
import DownloadButton from './DownloadButton';
import './OutputAttachments.css';

export const OutputAttachmentRow = ({ resource }) => {
  if (resource !== "") {
    return (
      <div className="OutputAttachmentRow">
        <div>{resource.name}</div>
        <DownloadButton
          url={'attachments/' + resource.uuid}
          fileName={resource.name}
          tooltip="general.download"
        />
      </div>
    );
  } else {
    return (
      <div className="OutputAttachmentRow">
      </div>
    );
  }
};

export const OutputAttachmentRowNoName = ({ resource }) => (
  <div className="OutputAttachmentRow" style={{ display: "block" }}>
    <DownloadButtonNoName
      url={'attachments/' + resource.uuid}
      fileName={resource.name}
      tooltip="general.download"
    />
  </div>
);

export const OutputAttachmentRowDisabled = ({ resource }) => (
  <div className="OutputAttachmentRow">
    <div style={{ color: '#c7c7c7' }}>{resource.name}</div>
  </div>
);


const OutputAttachments = props => {
  const attachments = props.resource.attachments;

  return (
    <div className="AttachmentOutput">
      {attachments ?
        attachments.map((a, i) =>
          <OutputAttachmentRow key={i} resource={a} />)
        : ''}
    </div>
  );
};

export default OutputAttachments;



// WEBPACK FOOTER //
// ./src/main/components/output/OutputAttachments.js